// extracted by mini-css-extract-plugin
module.exports = {"base":"fVBVie"};